export default "__VITE_ASSET__D06ATtU9__"